import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderMykolaiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-mykolaiv/create-distribution-order-mykolaiv",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderMykolaiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-mykolaiv/create-distribution-to-order-mykolaiv",
      params,
      callBackFn
    );
  },
  async getMykolaivAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-mykolaiv/get-mykolaiv-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
